import { ref, provide, inject } from 'vue';

const LoadingSymbol = Symbol('loading');

export function provideLoading() {
    // State
    const isLoading = ref(false);
    const loaderMessage = ref('');

    // Methods
    const showLoader = (message = '') => {
        loaderMessage.value = message;
        isLoading.value = true;

        // Add class to body to prevent scrolling
        document.body.classList.add('loading-active');
    };

    const hideLoader = () => {
        isLoading.value = false;
        loaderMessage.value = '';

        // Remove class from body
        document.body.classList.remove('loading-active');
    };

    // Expose the loading API
    provide(LoadingSymbol, {
        isLoading,
        loaderMessage,
        showLoader,
        hideLoader
    });
}

export function useLoading() {
    const loading = inject(LoadingSymbol);

    if (!loading) {
        throw new Error('useLoading must be used within a component that calls provideLoading!');
    }

    return loading;
}
